import React from 'react';

const SectionWrapper = ({ title, description, rightElement, children }) => {
    return (
        <div className={'flex flex-col gap-6 bg-white rounded-xl p-6'}>
            <div className={'flex justify-between items-start gap-4'}>
                <div className={'flex flex-col gap-2'}>
                    <h1 className='ft-xl font-medium text-gray-900'>{title}</h1>
                    {description && (
                        <p className='ft-sm font-normal text-gray-500'>{description}</p>
                    )}
                </div>
                {rightElement && (
                    <div className={'shrink-0'}>
                        {rightElement}
                    </div>
                )}
            </div>
            <div className={'flex flex-col gap-4'}>
                {children}
            </div>
        </div>
    );
};

export const FormField = ({ label, optional, children }) => {
    return (
        <div className={'flex flex-col gap-2'}>
            <label className='ft-sm font-medium text-gray-500'>
                {label}
                {optional && <span className='text-gray-400 font-light'> - (Optionnel)</span>}
            </label>
            {children}
        </div>
    );
};

export const inputClassName = "w-full h-10 pl-3 pr-3 ft-b placeholder-gray-600 border rounded-lg";
export const selectClassName = "w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg";
export const textareaClassName = "w-full p-3 ft-b placeholder-gray-600 border rounded-lg resize-none";

export default SectionWrapper;

